module.exports = __webpack_public_path__ + "static/media/instagram.87cab8a9.svg";